import React from 'react';

export default function AdminModule({ module }) {
  const modules = {
    fees: <FeeManagement />,
    messages: <MessageCenter />,
    certificates: <Certificates />,
    'pre-admission': <PreAdmission />,
    leave: <LeaveManagement />,
    feedback: <Feedback />,
    'projects-seminars': <ProjectsSeminars />,
    gallery: <GalleryModule />
  };
  return <div className="dash-page">{modules[module] || <p>Module Not Found</p>}</div>;
}

function FeeManagement() {
  return (
    <div><h1>💰 Fee Module & Financial Status</h1>
      <div className="stats-grid">
        <div className="stat-card" style={{borderTop:'4px solid #4CAF50'}}><div><h3>₹45.0L</h3><p>Total Fees</p></div></div>
        <div className="stat-card" style={{borderTop:'4px solid #2196F3'}}><div><h3>₹38.5L</h3><p>Collected</p></div></div>
        <div className="stat-card" style={{borderTop:'4px solid #F44336'}}><div><h3>₹6.5L</h3><p>Pending</p></div></div>
      </div>
      <table className="data-table"><thead><tr><th>Student</th><th>Amount</th><th>Status</th><th>Action</th></tr></thead><tbody><tr><td>Priya Patel</td><td>₹25,000</td><td><span className="badge red">Due</span></td><td><button className="btn-sm">Collect</button></td></tr></tbody></table>
    </div>
  );
}

function MessageCenter() {
  return <div><h1>💬 Message Center & Communication Tools</h1><p>Chat, broadcast announcements, parent-teacher messaging system.</p><div className="msg-box">📩 Inbox (12) | 📤 Sent (8) | 📢 Broadcast</div></div>;
}

function Certificates() {
  return <div><h1>🎖️ ID Cards & Certificates</h1><div className="cert-grid"><div className="cert-card">🆔 Student ID Card</div><div className="cert-card">📜 Bonafide Certificate</div><div className="cert-card">🏆 Achievement Cert</div><div className="cert-card">🚌 Transport Cert</div></div></div>;
}

function PreAdmission() {
  return <div><h1>📝 Pre-Admission CRUD</h1><p>Manage inquiries, applications, document verification, and enrollment status.</p><button className="btn btn-primary">+ Add New Applicant</button></div>;
}

function LeaveManagement() {
  return <div><h1>🏖️ Leave Management</h1><table className="data-table"><thead><tr><th>Name</th><th>Type</th><th>Dates</th><th>Status</th></tr></thead><tbody><tr><td>Rohan Mehta</td><td>Sick Leave</td><td>Apr 5 - Apr 7</td><td><span className="badge orange">Pending</span></td></tr></tbody></table></div>;
}

function Feedback() {
  return <div><h1>📝 Feedback & Grievances</h1><p>Collect and resolve feedback from students, parents, and staff.</p><div className="feedback-box">🌟 Rating: 4.8/5 | 📝 142 Reviews | ✅ 98% Resolved</div></div>;
}

function ProjectsSeminars() {
  return <div><h1>🎓 Projects & Seminars</h1><div className="proj-grid"><div className="proj-card">🔬 Research Project: Community Health</div><div className="proj-card">🎤 Seminar: AI in Nursing</div></div></div>;
}

function GalleryModule() {
  return <div><h1>🖼️ Gallery</h1><div className="gal-grid"><div className="gal-item">📷 Campus</div><div className="gal-item">📷 Labs</div><div className="gal-item">📷 Events</div></div></div>;
}